<main class="c-main" role="main">
    <div class="c-page-access">
      <div class="container u-pb30">
        <div class="row mobile--orange u-pt40">
          <div class="col-md-8">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a [routerLink]="['']"  >{{'MyAuthorizedAccessPortal.home' | translate}}</a></li>
                <li class="breadcrumb-item active" aria-current="page"> - <span>{{'MyAuthorizedAccessPortal.location' | translate}} </span></li>
              </ol>
            </nav>
            <h2 class="o-title js-txt3">{{'MyAuthorizedAccessPortal.title' | translate}}</h2>
            <p class="o-text o-text--description js-txt4"> {{'MyAuthorizedAccessPortal.subtitle' | translate}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12" *ngIf="accesses.length===0" >  <!--NGFOR-->
            <div class="u-pt20">
              <div class="c-card c-card--success">
                <div class="c-card__title">{{'MyAuthorizedAccessPortal.notAuthorized' | translate}}</div>
              </div>
            </div>
       
          </div>
          <div class="col-lg-12" *ngFor="let accesse of accesses">  <!--NGFOR-->
            <div class="u-pt20">
              <div class="c-card c-card--success">
                <div class="c-card__title">{{accesse.siteName | titlecase}}<span class="js-txt16"> {{'MyAuthorizedAccessPortal.titleTable' | translate}}</span></div>
                <div class="row"> 
                  <div class="col-md-4">
                    <p class="table__request"><strong class="js-txt6">{{'MyAuthorizedAccessPortal.labelRequestNumber' | translate}}: </strong> {{accesse.accessDetail.requestNumber}}</p>
                    <p><strong class="js-txt7">{{'MyAuthorizedAccessPortal.labelRequestor' | translate}}: </strong> {{accesse.requestor}}</p>
                  </div>
                  <div class="col-md-4"> 
                    <p> <strong class="js-txt9">{{'MyAuthorizedAccessPortal.labelZone' | translate}}: </strong> {{accesse.zoneName}} </p>
                    <p *ngIf="accesse.subZoneName != ''"> <strong class="js-txt9">{{'MyAuthorizedAccessPortal.labelSubzone' | translate}}: </strong> {{accesse.subZoneName}} </p>
                  </div>
                  <div class="col-md-4">
                    <div class="c-card__from"><i class="icon icon-calendar"></i>
                      <p> <strong class="js-txt10">{{'MyAuthorizedAccessPortal.labelFrom' | translate}} </strong> {{accesse.accessDetail.periodFrom | date: 'dd/MM/yyyy'}}</p>
                    </div>
                    <div class="c-card__to"><i class="icon icon-calendar"></i>
                      <p> <strong class="js-txt11">{{'MyAuthorizedAccessPortal.labelTo' | translate}} </strong> {{accesse.accessDetail.periodTo | date: 'dd/MM/yyyy'}}</p>
                    </div>
                  </div>
                </div><a class="btn-details js-txt12" [routerLink]="['/my-authorised-accesse/detail/'+accesse.accessDetail.requestNumber]">{{'MyAuthorizedAccessPortal.labelSeeDetails' | translate}}  </a>
              </div>
            </div>
       
          </div>
        </div>
      </div>
    </div>
  </main>